function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgCustomerHeadset(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M12 2a7.001 7.001 0 016.93 6.003H19a2 2 0 012 2v2.001a2 2 0 01-1.85 1.995l-.151.005v.223a7.002 7.002 0 01-5.621 6.864 1.499 1.499 0 01-2.878-.593 1.5 1.5 0 012.697-.903 5.5 5.5 0 004.298-5.147l.005-.221V9a5.5 5.5 0 00-10.995-.222L6.5 9v5.004H5a2 2 0 01-2-2v-2a2 2 0 012-2h.07A7.001 7.001 0 0112 2z"
  }));
}

SvgCustomerHeadset.clsName = 'icon-www__customer-headset';
SvgCustomerHeadset.remarkName = 'unknown';
export default SvgCustomerHeadset;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/CustomerHeadset.js
// module id = 2328
// module chunks = 17 18